import { tryOnMounted, useElementBounding, useElementSize } from "@vueuse/core";
import type { VNode } from "vue";

const navbarRef = ref();

export const setNavbarRef = (el: VNode | Ref<VNode> | Element) => {
  navbarRef.value = unref(el);
}

const pollForElement = (fn: () => Element | HTMLElement | undefined | null, timeout: number): Promise<Element | HTMLElement | undefined | null> => {
  const timeStarted = performance.now();

  return new Promise<Element | HTMLElement | undefined | null>((resolve) => {
    const loop = () => {
      const now = performance.now();
      const elapsed = now - timeStarted;

      const el = fn();
      if (el) {
        resolve(el);
        return;
      }

      if (elapsed >= timeout) {
        resolve(null);
        return;
      }
      requestAnimationFrame(loop);
    }

    requestAnimationFrame(loop);
  });
}

export const useNavbarSize = (): {
  width: ComputedRef<number>;
  height: ComputedRef<number>;
} => {
  let size = useElementSize(navbarRef);
  const rect = useElementBounding(navbarRef);

  tryOnMounted(async () => {
    const el = await pollForElement(() => document.getElementById("navbar-mobile"), 5000);
    if (el) {
      size.stop();
      navbarRef.value = el;
      size = useElementSize(navbarRef);
      rect.update();
    }
  });

  const width = computed(() => Math.max(size.width.value, rect.width.value));
  const height = computed(() => Math.max(size.height.value, rect.height.value));

  return { width, height };
};
